import { Component, OnInit, HostListener } from "@angular/core";
import { appConstants } from "src/app/constants/appConstants";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "app-refund-approved",
  templateUrl: "./refund-approved.component.html",
  styleUrls: ["./refund-approved.component.scss"],
})
export class RefundApprovedComponent implements OnInit {
  constructor(private _commonService: CommonService) {}
  showScroll: boolean;
  showScrollHeight = 300;
  hideScrollHeight = 10;
  refundApprovedList: Array<any> = [];
  page: number = 1;
  total_page: number = 1;
  pageSize: number = 50;
  pageLimit: number[] = [5, 10, 25, 50, 100];
  // selectedRequest: Array<any> = [];
  // reason: string = "";
  search: any = {
    phone: "",
    paymentId: "",
    // refundId: "",
  };
  ngOnInit() {
    this.getVerifiedList(this.page - 1);
  }
  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (
      (window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop) > this.showScrollHeight
    ) {
      this.showScroll = true;
    } else if (
      this.showScroll &&
      (window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop) < this.hideScrollHeight
    ) {
      this.showScroll = false;
    }
  }

  scrollToTop() {
    (function smoothscroll() {
      var currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - currentScroll / 5);
      }
    })();
  }
  getPageFromService(page) {
    if (page) {
      this.getVerifiedList(this.page - 1);
    }
  }
  getVerifiedList(page) {
    let url =
      appConstants.REFUND_APPROVED + page + "&pageSize=" + this.pageSize;
    this.getApiRequest(url);
  }
  changePageSize() {
    this.getVerifiedList(this.page - 1);
  }
  Search(key) {
    let url = appConstants.FILTER + "?page=0&status=VERIFIED&";
    switch (key) {
      case "phone":
        url = url + "filterType=phone&filterKey=" + this.search.phone;
        break;
      case "paymentId":
        url = url + "filterType=paymentId&filterKey=" + this.search.paymentId;
        break;
    }
    this.getApiRequest(url);
  }

  getApiRequest(url) {
    this._commonService.getRequest(url).subscribe(
      (res) => {
        this.refundApprovedList = res.refundsInfo.map((ele) => {
          return {
            ...ele,
            checked: false,
          };
        });

        this.total_page = res.totalPages * this.pageSize;
      },
      (err) => {
        console.log("err", err);
      }
    );
  }
  // updateStatus() {
  //   let url = appConstants.UPDATE_STATUS;
  //   const data = {
  //     id: this.selectedRequest,
  //     updatedBy: localStorage.getItem(appConstants.USER_NAME),
  //     reason: "SuveshTest",
  //   };
  //   this._commonService.PutRequest(data, url).subscribe(
  //     (res) => {
  //       this.getVerificationList(this.page);
  //     },
  //     (err) => {
  //       console.log("err", err);
  //     }
  //   );
  // }
  // checkedorder(event, id, i) {
  //   if (event.checked) {
  //     if (this.selectedRequest.length < 10) {
  //       this.selectedRequest.push(id);
  //       console.log("selectedRequest", this.selectedRequest);
  //     } else {
  //       setTimeout(() => {
  //         this.refundApprovedList[i].checked = false;
  //       });
  //     }
  //   } else {
  //     this.selectedRequest = this.selectedRequest.filter((item) => item !== id);
  //   }
  // }
}
